module.exports = __webpack_public_path__ + "img/sbg.7f432c9e.jpeg";